export const initialState = {
  createdAt: "",
  deepLink: "",
  email: "",
  hasCustomScript: false,
  hasReviewed: false,
  hasProducts: false,
  hasCustomerExperiences: false,
  id: null,
  isAtRiskOfBadReview: false,
  isEnabled: false,
  isInstalled: false,
  isOnboarded: false,
  locale: "en",
  name: null,
  phone: null,
  shopifyPlan: null,
  timezone: "UTC",
  scriptVersion: null,
  shopifyDomain: null,
  updatedAt: null,
  deletedAt: null,
  accessToken: null,
  customDomain: {
    error: null,
    status: "pending",
    email: "",
    dnsRecords: [],
  },
  subscription: {
    subscriptionPlan: "CORE",
    subscriptionPriceOption: "FREE",
    subscriptionVersion: 1,
    hasAddOn: false,
    hasUnlimitedOrders: false,
    numberOfOrders: 0,
    numberOfOrdersUsed: 0,
    lifetimeOrderLimit: 20,
    lifetimeOrdersUsed: 0,
    pricePaid: 0,
    planPaymentFrequence: null,
    billingCycleStartDate: null,
    quotaExhaustedAt: null,
    disabledAt: null,
  },
  settings: {
    selectors: {
      form: 'form[action*="/cart/add"], [data-block-id="buy_buttons"] .shopify-product-form, product-sticky-bar',
      addToCartButton: 'button[type="submit"], input[type="submit"]',
      addToCartButtonText: null,
      variant: 'select[name="id"], input[type="radio"][name^="option"], .variant-input',
      message: 'button[type="submit"]',
      widgets: 'button[type="submit"]',
      badge: ".product__media-gallery, .product-media-container, .product-single__media-wrapper, .product-gallery",
      quantityInput: 'input[name="quantity"], .quantity__input',
      priceContainer: ".price, .product__price, .product-single__price",
      shopifyPaymentButton: '.shopify-payment-button, [data-shopify="payment-button"]',
      variantChangingTime: 50,
      collection: {
        productCard: ".product-card, .card--product, .product-item, .product-card-wrapper",
        badge: ".card__inner",
        form: 'form[action*="/cart/add"]',
        addToCartButton: 'button[type="submit"], input[type="submit"]',
        addToCartButtonText: null,
      },
      quickView: {
        button: ".quick-add__submit, .quick-view-btn, [data-quick-add], .product-card__quick-add-button",
        container: ".quick-add-modal__content-info:visible, .quick-buy-modal:visible",
        form: 'form[action*="/cart/add"], [data-block-id="buy_buttons"] .shopify-product-form, product-sticky-bar',
        addToCartButton: 'button[type="submit"], input[type="submit"]',
        addToCartButtonText: null,
        variant: 'select[name="id"], input[name="id"], input[type="radio"][name^="option"], .variant-input',
        message: 'button[type="submit"]',
        widgets: 'button[type="submit"]',
        badge: ".product__media-gallery, .product-media-container, .product-gallery",
        shopifyPaymentButton: '.shopify-payment-button, [data-shopify="payment-button"]',
      },
    },
  },
};
